import './404.css';

export default function NotFound() {
  return (
    <section className="not-found">
      <h3>~功能正在建设中, 敬请期待~</h3>
      <section className="icon"></section>
    </section>
  )
}